import {HouseNo, HouseNoFormat} from "../../data/models/houseno/houseno";
import {BaseData} from "../../data/models/base-data.model";

/**
 * Baut einen HouseNoVektor aus den Eingabefeldern. Country in Großschrift erwartet ('A' für Österreich).
 * `HouseNoFormat.ofCountryCode` reduziert intern auf den ersten Buchstaben, daher matchen 'A' und 'AT'
 * gleichermaßen — eine explizite 'AT'-Sonderbehandlung ist nicht nötig.
 */
export function getHouseNo(houseNo: string, countryKey: string, stock?: string, stiege?: string, tuer?: string): string {
  if (HouseNoFormat.ofCountryCode(countryKey?.toUpperCase() ?? '') === HouseNoFormat.AUSTRIA) {
    return HouseNo.ofAustriaParts(houseNo ?? '', stiege ?? '', stock ?? '', tuer ?? '').houseNoVec;
  }
  return HouseNo.ofDefault(houseNo ?? '').houseNoVec;
}

/**
 * Formatiert einen HouseNoVektor menschenlesbar (Slash-separiert für Austria, pur für Default).
 */
export function transformHouseNo(houseno: string): string {
  if (!houseno) {
    return houseno;
  }
  try {
    return HouseNo.formatForHuman(houseno);
  } catch (e) {
    console.error("HouseNo konnte nicht formatiert werden:", houseno, e);
    return houseno;
  }
}

/**
 * Der Titel einer Person für die Anzeige (z. B. "Prof.").
 *
 * Er liegt in zwei Formen vor: In den Formularen der Bestellstrecke hält ihn das mat-select als
 * Stammdatum der 'titles', aus dem Backend kommt dagegen nur dessen Schlüssel. Ausgegeben wird in
 * beiden Fällen die Beschreibung - ein Stammdatum direkt in die Vorlage gesetzt erschiene dort als
 * "[object Object]". Ein Schlüssel, zu dem es kein Stammdatum gibt, erscheint unverändert.
 */
export function titleDescription(title: string | BaseData | null | undefined, titles: BaseData[] | null | undefined): string {
  if (!title) {
    return '';
  }
  if (typeof title !== 'string') {
    return title.description ?? '';
  }
  return titles?.find(baseData => baseData.key === title)?.description ?? title;
}
